import { CHECKINS_DOC, COOKS_DOC, GAMES_DOC } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { CheckinArchivePage } from './CheckinArchivePage';
import { CheckinComposerPage } from './CheckinComposerPage';
import { CheckinFeedPage } from './CheckinFeedPage';
import { CheckinPhotoPage } from './CheckinPhotoPage';

/**
 * Check-in module (client side, WS-13).
 *
 * Nav order 40 — Calendar · Lists · Recipes · Check-in. The original design put Check-in
 * in the centre tab slot ("the one you open with no goal in mind"); the owner overrode
 * that on 2026-07-31 in favour of the plainer left-to-right reading order once Household
 * moved out of the nav entirely (docs/DECISIONS.md). The registry sorts on
 * `NavEntry.order`, so this is one number rather than an ordering mechanism; the sibling
 * feature modules take 10/20/30.
 *
 * `GAMES_DOC` is subscribed here too (ROADMAP "Games in the family timeline") — the feed
 * reads the family games registry read-only and interleaves finished games as fact cards
 * (`feedItems.ts`). This module never opens a `game:<id>` content doc; that belongs to the
 * games module and its board UI.
 *
 * `COOKS_DOC` joins it for the same reason (owner ask 2026-08-18) — "Dan cooked Smoked
 * salmon" as a fact card in the same chronology (`cooks.ts`, `components/CookFeedCard.tsx`).
 * Read-only here too: the recipes module owns every write to the cook log, and this module
 * never opens `RECIPES_DOC` — a cook card renders entirely from its own denormalized
 * `recipeTitle`, so the feed needs no view of the recipe box at all.
 */
export const checkinWebModule: WebModule = {
  id: 'checkin',
  nav: { label: 'Check-in', path: '/checkin', icon: '📷', order: 40 },
  routes: [
    { path: '/checkin', component: CheckinFeedPage },
    { path: '/checkin/new', component: CheckinComposerPage },
    { path: '/checkin/archive', component: CheckinArchivePage },
    { path: '/checkin/p/:checkinId', component: CheckinPhotoPage },
  ],
  docs: [CHECKINS_DOC, GAMES_DOC, COOKS_DOC],
};
